// Kiid Bundle Builder V2 helper. The picking, limits, cup choice and add to cart are the Product
// Selector's own code (kiid-product-selector.js). This file only adds what the Gift Bundle look needs:
//  1. a colored offset shadow on each card, taken from the card's photo (as the Gift Bundle page does),
//  2. the discount pill and the summary text ("2 flavors selected", the hint), updated after every render.

(function () {
  var SELECTOR = 'kiid-product-selector';

  // ---- 1. shadow colors ----
  function applyShadow(card, thief) {
    var img = card.querySelector('img');
    if (!img) return;

    function apply() {
      try {
        var rgb = thief.getColor(img);
        card.style.setProperty('--kbb-shadow', 'rgb(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ')');
      } catch (error) {
        // A photo that can't be read keeps the accent color.
      }
    }

    if (img.complete && img.naturalWidth > 0) apply();
    else img.addEventListener('load', apply, { once: true });
  }

  function colorCards(root) {
    if (typeof window.ColorThief === 'undefined') return;
    var thief = new window.ColorThief();
    root.querySelectorAll('.kbb2__card').forEach(function (card) {
      applyShadow(card, thief);
    });
  }

  // ---- 2. pill and summary text ----
  function fill(template, count) {
    return (template || '').replace('{count}', count);
  }

  function update(root) {
    if (!root.startersPicked) return; // the selector isn't ready yet

    var needed = root.flavorCount;
    var picked = root.startersPicked().length;
    var remaining = Math.max(needed - picked, 0);
    var cup = root.cups.find(function (item) {
      return item.dataset.variant === root.cup && !item.closest('.kps__cup').hidden;
    });
    var hasCupStep = root.cups.some(function (item) {
      return !item.closest('.kps__cup').hidden;
    });

    var pill = root.querySelector('[data-pill]');
    var hint = root.querySelector('[data-hint]');
    var count = root.querySelector('[data-count]');
    var countLabel = root.querySelector('[data-count-label]');
    var cupLabel = root.dataset.cupSummary || 'Cup';

    var pillText;
    if (remaining > 0) {
      pillText = fill(remaining === 1 ? root.dataset.pillOne : root.dataset.pillOther, remaining);
    } else if (hasCupStep && !cup) {
      pillText = root.dataset.pillCup;
    } else {
      pillText = root.dataset.pillDone;
    }
    if (pill) pill.textContent = pillText || '';

    if (count) count.textContent = picked;
    if (countLabel) countLabel.textContent = picked === 1 ? root.dataset.countOne : root.dataset.countOther;
    if (hint) hint.textContent = cup ? cupLabel + ': ' + cup.dataset.name : '';
  }

  // The selector re-renders after every change but does not announce it, so wrap render() once to
  // announce it. This only adds an event; it does not change what render() does.
  function hookRender() {
    var proto = customElements.get(SELECTOR).prototype;
    if (proto.__kiidRenderEvent) return;
    var original = proto.render;
    proto.render = function () {
      original.apply(this, arguments);
      this.dispatchEvent(new CustomEvent('kiid:selector:render', { bubbles: true }));
    };
    proto.__kiidRenderEvent = true;
  }

  function start() {
    var roots = Array.prototype.slice.call(document.querySelectorAll(SELECTOR + '.kbb2'));
    if (!roots.length) return;

    customElements.whenDefined(SELECTOR).then(function () {
      hookRender();
      roots.forEach(function (root) {
        root.addEventListener('kiid:selector:render', function () {
          update(root);
        });
        // The first render happened before the hook was in place.
        update(root);
        colorCards(root);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  // Photos can finish loading after the page, and ColorThief loads late: try again once everything is in.
  window.addEventListener('load', function () {
    document.querySelectorAll(SELECTOR + '.kbb2').forEach(colorCards);
  });
})();
